export default "__VITE_ASSET__C5ThS3L3__"